import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import * as appContextEffect from './app-context.effects';
import { appContextKey } from '@app/core/store/app-context/app-context.state';
import { appContextReducer } from '@app/core/store/app-context/app-context.reducer';

export function provideAppContextStore(): EnvironmentProviders[] {
  return [provideState({ name: appContextKey, reducer: appContextReducer }), provideEffects(appContextEffect)];
}
